module.exports = __webpack_public_path__ + "img/fiji.4d078b32.svg";